import { Auth } from 'aws-amplify';
import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { checkSessionExpiration } from './AuthService';

const defaultHeader: IHeader = {
  headers: {
    Authorization: null,
    'Content-Type': 'application/json',
  },
};

export class HttpRequest {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create();

    this.axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response && error.response.status === 401) {
          await this.signOut();
        }
        return Promise.reject(error);
      }
    );
  }

  public async Get<T>(request: string): Promise<AxiosRequestConfig> {
    const token = `Bearer ${await this.GetToken()}`;
    const headers = {
      headers: {
        ...defaultHeader.headers,
        Authorization: token,
      },
    };

    const response = await this.axiosInstance.get(request, headers);
    return response;
  }

  public async Post<T>(request: string, object: object): Promise<AxiosRequestConfig> {
    const token = `Bearer ${await this.GetToken()}`;
    const headers = {
      headers: {
        ...defaultHeader.headers,
        Authorization: token,
      },
    };

    const response = await this.axiosInstance.post(request, object, headers);
    return response;
  }

  public async Put<T>(request: string, body: any, config: any): Promise<AxiosRequestConfig> {
    const response = await this.axiosInstance.put(request, body, config);
    return response;
  }

  public async PutWithAuth<T>(request: string, object: object): Promise<AxiosRequestConfig> {
    const token = `Bearer ${await this.GetToken()}`;
    const headers = {
      headers: {
        ...defaultHeader.headers,
        Authorization: token,
      },
    };

    const response = await this.axiosInstance.put(request, object, headers);
    return response;
  }

  private async GetToken(): Promise<string> {
    try {
      const currentSession = await Auth.currentSession();

      if (await checkSessionExpiration()) {
        await this.signOut();
      }
      return currentSession.getIdToken().getJwtToken();
    } catch (error) {
      await this.signOut();
      throw new Error('No se pudo obtener el token. Se ha cerrado la sesión.');
    }
  }

  private async signOut(): Promise<void> {
    localStorage.removeItem('id_token');
    localStorage.removeItem('id_email');
    localStorage.removeItem('role');

    await Auth.signOut();
    window.location.assign('/app/iniciar-sesion?sessionExpired=true');
  }

  public async GetWithoutToken<T>(request: string): Promise<AxiosRequestConfig> {
    const response = await this.axiosInstance.get(request);
    return response;
  }

  public async Delete<T>(request: string): Promise<AxiosRequestConfig> {
    const token = `Bearer ${await this.GetToken()}`;
    const headers = {
      headers: {
        ...defaultHeader.headers,
        Authorization: token,
      },
    };

    const response = await this.axiosInstance.delete(request, headers);
    return response;
  }
}

export default HttpRequest;
